var classes = {"productListSliderInformation":"eV5tf"};

export { classes as default };
